import _, { groupBy, isUndefined, min } from "lodash";

import type { IOrganizationGroups } from "@types";
import { getOrganizationGroups } from "features/vulnerabilities/utils";
import type {
  IFindingsFormatted,
  IVulnerabilityToReattack,
} from "pages/to-do/reattacks/types";

const noDate = (finding: IFindingsFormatted): boolean => {
  return finding.oldestReattackRequestedDate !== "-";
};

const formatVulnerabilities = (
  organizationsGroups: IOrganizationGroups[] | undefined,
  allVulnerabilities: IVulnerabilityToReattack[],
): IFindingsFormatted[] => {
  const formatted = groupBy(
    allVulnerabilities,
    (vuln: IVulnerabilityToReattack): string => vuln.finding.id,
  );

  const findings = Object.entries(formatted).map(
    ([id, vulnerabilities]: [
      string,
      IVulnerabilityToReattack[],
    ]): IFindingsFormatted => {
      const groupName =
        vulnerabilities.length > 0 ? vulnerabilities[0].groupName : "";
      const title =
        vulnerabilities.length > 0 ? vulnerabilities[0].finding.title : "";
      const organizationGroups = getOrganizationGroups(
        organizationsGroups,
        groupName,
      );
      const organizationName =
        organizationGroups === undefined ? "" : organizationGroups.name;
      const vulnsDates = vulnerabilities.map(
        (vuln): string => vuln.lastRequestedReattackDate ?? "",
      );
      const minDate = min(vulnsDates);
      const oldestReattackRequestedDate = isUndefined(minDate) ? "-" : minDate;

      return {
        groupName,
        id,
        oldestReattackRequestedDate,
        organizationName,
        requested: String(vulnerabilities.length),
        title,
        url: `https://app.fluidattacks.com/orgs/${organizationName}/groups/${groupName}/vulns/${id}/locations`,
      };
    },
  );

  const fmtd = findings.filter(noDate);

  return _.orderBy(fmtd, ["oldestReattackRequestedDate"], ["asc"]);
};

export { formatVulnerabilities };
